import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import '../styles/dashboardStyles.css';
import Header from '../components/header';
import Navbar from '../components/NavBar';
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { loginRequest } from '../auth/AuthConfig';
import { useNavigate } from 'react-router-dom';

const Dashboard: React.FC = () => {
    const [, setSelectedProcedure] = useState<any | null>(null);
    const navigate = useNavigate();

    return (
        <MsalAuthenticationTemplate 
            interactionType={InteractionType.Redirect}
            authenticationRequest={loginRequest}
        >
            <div className="full-height-form p-fluid" >
                <Helmet>
                    <title>Main Dashboard</title>
                </Helmet>
                <Header />
                <Navbar />
                <h1 className='Ph1'>Main Dashboard</h1>

            </div>
        </MsalAuthenticationTemplate>
    );
};

export default Dashboard;